import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["controlled-gif", { playing: _ctx.playing }])
  }, [
    (_ctx.stillFrameUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "controlled-gif-layer controlled-gif-still",
          src: _ctx.stillFrameUrl,
          alt: _ctx.alt,
          draggable: "false",
          onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleStillFrameError && _ctx.handleStillFrameError(...args)))
        }, null, 40, _hoisted_1))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock("img", {
      key: _ctx.motionKey,
      class: _normalizeClass(["controlled-gif-layer controlled-gif-motion", { 'fallback-visible': !_ctx.stillFrameUrl }]),
      src: _ctx.src,
      alt: _ctx.alt,
      draggable: "false"
    }, null, 10, _hoisted_2))
  ], 2))
}